// extracted by mini-css-extract-plugin
module.exports = {"blogTitle":"style_blogTitle__r_EAX"};